import { render, staticRenderFns } from "./PerformanceScoreInfo.vue?vue&type=template&id=7bdc8488&scoped=true"
import script from "./PerformanceScoreInfo.vue?vue&type=script&lang=js"
export * from "./PerformanceScoreInfo.vue?vue&type=script&lang=js"
import style0 from "./PerformanceScoreInfo.vue?vue&type=style&index=0&id=7bdc8488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc8488",
  null
  
)

export default component.exports